export default __webpack_public_path__ + "static/media/probleme-resolu-application-min.2e942746.jpg";